const apiURLBuilder = require('../core/apiURLBuilder');
import { history } from 'routes/history';
const Api = require('../services/api');
const actionTypes = require('constants/actionTypes');
const { BASE_PATH } = require('constants/index');

const postML2 = (cookie, request_id, accessToken) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: 'Bearer ' + accessToken,
        },
        query: {
            cookie: cookie,
            requestId: request_id,
        },
    };

    return Api.post(apiURLBuilder.getURL('postML2'), saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = response.body || [];

            dispatch({
                type: actionTypes.LOAD_ML2,
                data: data,
            });
        } else {
            history.push(BASE_PATH + '/errors');
        }
    });
};

const postJaffar = (accessToken, cb) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: 'Bearer ' + accessToken,
        },
        query: {},
    };

    return Api.post(apiURLBuilder.getURL('postJaffar'), saveRequestData)
        .then(response => {
            const data = response.body || [];
            dispatch({
                type: actionTypes.LOAD_JAFFAR,
                data: data,
            });
            cb(true, data);
        })
        .catch(() => cb(false));
};

const setScoringML2 = data => dispatch => {
    dispatch({
        type: actionTypes.LOAD_ML2,
        data: data,
    });
};

const setScoringJaffar = data => dispatch => {
    dispatch({
        type: actionTypes.LOAD_JAFFAR,
        data: data,
    });
};

const getLimitJaffar = (accessToken, cb) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: 'Bearer ' + accessToken,
        },
        query: {},
    };

    return Api.post(apiURLBuilder.getURL('getLimitJaffar'), saveRequestData)
        .then(response => {
            const data = response.body || [];
            dispatch({
                type: actionTypes.LOAD_JAFFAR,
                data: data,
            });
            cb(true);
        })
        .catch(() => cb(false));
};

export default {
    postML2,
    postJaffar,
    setScoringML2,
    setScoringJaffar,
    getLimitJaffar,
};
